import request from '@/utils/request'

let LogApi = {

    getSecurityLog(data, errorback) {
    return request._post('/shop/plus.log.Index/getSecurityLog', data, errorback);
  },
  getSystemLog(data, errorback) {//获取拿货记录
    return request._post('/shop/plus.log.Index/getSystemLog', data, errorback);
  },

  
}
export default LogApi;



// WEBPACK FOOTER //
// ./src/api/log.js